import { t } from "ttag";

import type { RelativeDatePickerValue } from "metabase/querying/filters/types";
import { Switch } from "metabase/ui";

import {
  getIncludeCurrent,
  getIncludeCurrentLabel,
  setIncludeCurrent,
} from "../DateIntervalPicker/utils";

interface IncludeCurrentSwitchProps {
  value: RelativeDatePickerValue;
  onChange: (value: RelativeDatePickerValue) => void;
}

function getIncludeCurrentLabel(unit: string): string {
  const MONGOLIAN_LABELS: Record<string, string> = {
    minute: "одоогийн минутыг багтаах",
    hour: "одоогийн цагийг багтаах",
    day: "өнөөдрийг багтаах",
    week: "энэ долоо хоногийг багтаах",
    month: "энэ сарыг багтаах",
    quarter: "энэ улирлыг багтаах",
    year: "энэ жилийг багтаах",
  };

  return MONGOLIAN_LABELS[unit] || unit;
}
export const IncludeCurrentSwitch = ({
  value,
  onChange,
}: IncludeCurrentSwitchProps) => {
  const includeCurrent = getIncludeCurrent(value);

  const handleIncludeCurrentSwitch = () => {
    onChange(setIncludeCurrent(value, !includeCurrent));
  };

  return (
    <Switch
      aria-checked={includeCurrent}
      checked={includeCurrent}
      data-testid="include-current-interval-option"
      label={getIncludeCurrentLabel(value.unit)}
      labelPosition="right"
      onChange={handleIncludeCurrentSwitch}
      size="sm"
    />
  );
};
